import { render, staticRenderFns } from "./CompareGrafik.vue?vue&type=template&id=0885cf1e&scoped=true&"
import script from "./CompareGrafik.vue?vue&type=script&lang=js&"
export * from "./CompareGrafik.vue?vue&type=script&lang=js&"
import style0 from "./CompareGrafik.vue?vue&type=style&index=0&id=0885cf1e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0885cf1e",
  null
  
)

export default component.exports